import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import ribbon from './reducers/ribbon';

export default combineReducers({
  form,
  ribbon,
  config: (state = {}) => state,
});



// WEBPACK FOOTER //
// ./src/domain/reducer.js